export default __webpack_public_path__ + "static/media/revetement.5bb10573.svg";